export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-die-five-ef0c39dc649fe9f3195b5b0d0549ddad.svg";